<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="15.984" height="29.191" viewBox="0 0 15.984 29.191">
        <path
            d="M5566.236,1789.248l14.381,14.407-14.381,13.711"
            transform="translate(-5565.705 -1788.718)"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
        />
    </svg>
</template>
